import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let submit = useDataSubmit({
    context: 'connection',
    viewPath: props.viewPath,
  })

  let connection_resource_id = useDataValue({
    viewPath: props.viewPath,
    context: 'connection',
    path: 'current_location_resource.id',
  })

  return function onClick() {
    submit({ type: 'disable_connection', connection_resource_id })
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
